import React from 'react';

import { observer } from 'mobx-react';
import Box from '@mui/material/Box';

import { formatMoment } from 'utils/formatters/timezone';

import UserRow from 'components/UserRow';

import { EmptyValue } from 'components/SharedFormComponents/CustomFieldDisplayValue/styles';

import { StyledContainer, Value, StyledRowTitle } from './styles';
import { NoneEditableValuesProps } from './types';

const InfoField: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <Box sx={{ flex: 1 }}>
    <div>
      <StyledRowTitle>{label}</StyledRowTitle>
    </div>
    <div>{children}</div>
  </Box>
);

const OriginalSubmissionHeader: React.FC<NoneEditableValuesProps> = ({
  id,
  created,
  createdBy,
}): React.ReactElement => (
  <StyledContainer>
    <InfoField label="Event ID">
      <Value>{`E${id}`}</Value>
    </InfoField>

    <InfoField label="Submitted">
      <Value data-testid="entity-created-date">{formatMoment(created, 'D MMM YYYY, HH:mm')}</Value>
    </InfoField>

    <InfoField label="Reporter">{createdBy ? <UserRow user={createdBy} /> : <EmptyValue>-</EmptyValue>}</InfoField>
  </StyledContainer>
);

export default observer(OriginalSubmissionHeader);
